import Container from "layouts/container/Container";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext } from "react";
import DeskTopTrackOrder from "./trackorder/DeskTopTrackOrder";
import MobileTrackOrder from "./trackorder/MobileTrackOrder";


function TrackOrderLayout() {

  const { isMobile } = useContext(BrowserDetectContext);
  return (

    <Container backgroundColor={"white"} minWidth={!isMobile && 1000}>
      {
        isMobile
          ?
          <MobileTrackOrder />
          :
          <DeskTopTrackOrder />
      }

    </Container>
  );
}

export default TrackOrderLayout;
